import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import './../../layout/login.css';
import { ServiceApi } from "./../../service/Api";
import { ProgressSpinner } from 'primereact/progressspinner';
import { Toast } from 'primereact/toast';
import 'primereact/resources/themes/saga-blue/theme.css';
import { ScreensLGPDForm } from '../../screens/LGPD/Form';
import md5 from 'md5';
import './../../layout/quill.css';
import { License } from '../License/License';
import { Footer } from '../Footer/Footer';
import 'primeicons/primeicons.css';

import Testimonial from "./Testimonial";
import 'primereact/resources/primereact.min.css';

import QRCodeImage from "./../../images/qrcode_image.png";// Importação da imagem
import IcoUser from './../../images/Icons/UserRounded.svg';
import IcoLock from './../../images/Icons/Lock.svg';
import Logo_white from './../../images/Icons/Logo_white.svg';

export class ComponentsLoginForm extends Component {

    constructor() {
        super();
        this.state = {
            usuario: "",
            senha: "",
            codigo: "",
            eventLembrarSenha: false,
            eventEnviarCodigo: false,
            naoRecebiMeuCodigo: false,
            ocultarLinkReenviarCodigo: false,
            loadingLogin: false,
            config: null,
            currentImageIndex: 0,
        };


    }

    static defaultdProps = {
        onExecute: null
    }

    static propTypes = {
        onExecute: PropTypes.func
    }

    componentDidMount() {

        this.carregarConfig();

        const hash = window.location.hash; // Ex: "#/?id=35707&pass=D33DDA"
        const params = new URLSearchParams(hash.split('?')[1]);

        const id = params.get("id");
        const pass = params.get("pass");

        if (id && pass) {
            console.log("Login via URL detectado:", id, pass);
            this.setState({ usuario: id, senha: pass }, () => {
                this.handleLoginClick();
            });
        }
    }

    componentWillUnmount() {
        if (this.imageInterval) clearInterval(this.imageInterval);
    }


    carregarConfig = async () => {
        // Obtém o primeiro segmento do path dinamicamente:
        const getCandidateBases = () => {
            const parts = (window.location.pathname || "/")
                .split("/")
                .filter(Boolean);

            const bases = [];
            for (let i = parts.length; i >= 1; i--) {
                bases.push("/" + parts.slice(0, i).join("/"));
            }

            try {
                const params = new URLSearchParams(window.location.search);
                const override = params.get("basePath");
                if (override && override.startsWith("/") && override !== "/") {
                    bases.unshift(override.replace(/\/+$/, "")); // sem barra final
                }
            } catch { }

            const unique = [...new Set(bases.map(b => b.replace(/\/+$/, "")))];

            // Fallback opcional para raiz (APENAS PARA DESENVOLVIMENTO)
            // Basta comentar/descomentar a linha abaixo:
            //unique.push("");

            return unique;
        };

        const fetchWithTimeout = async (url, options = {}, ms = 7000) => {
            const controller = new AbortController();
            const id = setTimeout(() => controller.abort(), ms);
            try {
                return await fetch(url, { ...options, signal: controller.signal });
            } finally {
                clearTimeout(id);
            }
        };

        const applyConfigToState = (config) => {
            this.setState({
                config,
                configOriginal: JSON.parse(JSON.stringify(config)),
                titulo: config.login?.titulo || "",
                subtitulo: config.login?.subtitulo || "",
                depoimentos: config.depoimentos || [],
                depoimentoAtual: config.depoimentos?.length > 0
                    ? {
                        nome: config.depoimentos[0].nome,
                        cargo: config.depoimentos[0].cargo,
                        texto: config.depoimentos[0].texto
                    }
                    : { nome: "", cargo: "", texto: "" },
                imagens: config.carrosselImagens || [],
                QrCodeImage: config.qrCode?.imagem || "",
                QrCodeText: config.qrCode?.texto || ""
            });
        };

        try {
            const bases = getCandidateBases();
            if (bases.length === 0) {
                throw new Error("Nenhuma basePath candidata (app na raiz não é permitido).");
            }

            let lastError = null;
            for (const base of bases) {
                const prefix = base === "" ? "" : base;
                const url = `${prefix}/config.json?_=${Date.now()}`;

                try {
                    const res = await fetchWithTimeout(url, { cache: "no-store" });
                    if (!res.ok) throw new Error(`HTTP ${res.status}`);
                    const config = await res.json();
                    applyConfigToState(config);
                    return;
                } catch (err) {
                    console.warn(`[config] Falha em ${url}:`, err);
                    lastError = err;
                }
            }

            throw lastError || new Error("Arquivo config não foi encontrado");
        } catch (error) {
            console.error("Erro ao carregar config:", error);
        }
    };


    startImageRotation = (total) => {
        if (this.imageInterval) clearInterval(this.imageInterval);

        this.imageInterval = setInterval(() => {
            this.setState(prev => ({
                currentImageIndex: (prev.currentImageIndex + 1) % total
            }));
        }, 5000); // 5 segundos
    };



    componentDidUpdate(prevProps) {
        // Quando login falha, desativa loading
        if (!prevProps.erroLogin && this.props.erroLogin) {
            this.setState({ loadingLogin: false });
        }
    }

    componentWillReceiveProps(props) {

        if (this.props.msgEmailNaoCadastrado)
            this.setState({ naoRecebiMeuCodigo: true });

        if (this.props.dadosQRCode) {
            this.setState({
                usuario: this.props.dadosQRCode.usuario,
                senha: this.props.dadosQRCode.senha
            })
        }

    }

    handleLoginClick() {
        if (this.props.onExecute == null)
            return;

        this.setState({ loadingLogin: true });

        this.props.onExecute({
            usuario: this.state.usuario,
            senha: this.state.senha,
            codigoAcesso: this.state.codigo ? md5(this.state.codigo) : "",
            reenviarCodigo: false
        });
    }

    handleKeyPress = (event) => {
        if (event.key == 'Enter')
            this.handleLoginClick();
    }

    handleLembrarSenha() {
        this.setState({ eventLembrarSenha: true });
        if (this.state.usuario == "") {
            alert("Digite o login de usuário");
            document.getElementById("textLogin").focus();
        } else {
            var tipo = "medico";
            var URL = window.location.hash;
            if (URL == "#/" || URL == "/") {
                tipo = "paciente";
            }
            let url = `Api/Login/PostLembrarSenha?tipo=${tipo}&usuario=${this.state.usuario}&sistema=Portal`;
            ServiceApi.post(url).then(res => this.retLembrarSenha(res))
                .catch(ex => console.log(ex));
        }
    }

    retLembrarSenha(res) {
        if (res) {
            this.showSuccess();
        } else {
            this.showError();
        }
        this.setState({
            eventLembrarSenha: false
        })
    }

    handleReenviarCodigo() {

        this.setState({ ocultarLinkReenviarCodigo: true });

        var cnt = 0;

        var tm = setInterval(() => {
            cnt++;
            if (cnt === 60) {
                clearTimeout(tm);
                this.setState({ ocultarLinkReenviarCodigo: false });
            }
        }, 1000);

        this.props.onExecute({
            usuario: this.state.usuario,
            senha: this.state.senha,
            reenviarCodigo: true,
        });

    }

    handleNaoRecebiMeuCodigo() {
        this.props.onExecuteNaoRecebiCodigo();
        this.setState({ naoRecebiMeuCodigo: true });
    }

    mobilecheck() {
        var check = false;
        (function (a) {
            if (
                /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
                    a
                ) ||
                /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
                    a.substr(0, 4)
                )
            )
                check = true;
        })(navigator.userAgent || navigator.vendor || window.opera);
        return check;
    }

    showSuccess() {
        this.toast.show({ closable: false, severity: 'success', summary: 'Sucesso!', detail: 'A senha foi enviada para seu email de cadastro.', life: 3000 });
    }

    showError() {
        this.toast.show({ closable: false, severity: 'error', summary: 'Falha', detail: 'Falha ao enviar email. Verifique as configurações de segurança do seu provedor.', life: 3000 });
    }


    render() {

        const titulo = this.state.config?.login?.titulo;
        const subtitulo = this.state.config?.login?.subtitulo;
        const qrcodeimagem = this.state.config?.qrCode?.imagem;
        const qrcodetexto = this.state.config?.qrCode?.texto;
        const depoimentos = this.state.config?.depoimentos;

        const carrosselImagens = this.state.config?.carrosselImagens;

        const tiposUsuario = [
            { label: 'Médico Solicitante', value: '0' },
            { label: 'Médico Executante', value: '1' }
        ];


        const boxLoginSenha = <div>
            {!this.props.isLicense ?
                <div className="login-page__form">
                    <div>
                        <div style={{ marginTop: '10px' }}>
                            <label className="login-page__label">Login:</label>
                        </div>
                        <InputText
                            id="textLogin"
                            className={`login-page__input--login ${this.props.erroLogin ? 'login-page__input--login--error' : ''}`}
                            value={this.state.usuario}
                            onChange={(e) => {
                                this.setState({ usuario: e.target.value });
                                this.props.onResetErroLogin(); // ← zera erro ao digitar
                            }}
                            placeholder="Insira aqui o seu código de login"
                        />
                    </div>

                    <div >
                        <div style={{ marginTop: '20px', position: 'relative' }}>
                            <label className="login-page__label">Senha:</label>
                        </div>
                        <span className={this.props.erroLogin ? 'login-page__control--password' : ''}>
                            <Password
                                className="login-page__input--password"
                                value={this.state.senha}
                                onKeyPress={this.handleKeyPress}
                                onChange={(e) => {
                                    this.setState({ senha: e.target.value });
                                    this.props.onResetErroLogin(); // ← zera erro ao digitar                                    
                                }}
                                placeholder="Digite sua senha"
                                toggleMask
                                feedback={false}
                            />
                            {this.props.erroLogin && (
                                <p className="login-page__error-message">Prontuário ou senha inválidos.</p>
                            )}
                        </span>
                    </div>

                    <div className="login-page__button">
                        <Button
                            id="btnLogin"
                            className="btn-alinhado"
                            onClick={this.handleLoginClick.bind(this)}
                            disabled={this.state.loadingLogin}
                        >
                            {this.state.loadingLogin ? (
                                <>
                                    <i className="pi pi-spin pi-spinner login-btn-icon" style={{ marginRight: '8px' }} />
                                    Carregando...
                                </>
                            ) : (
                                <>
                                    <span>Acessar exames</span>
                                    <i className="pi pi-angle-right icone-do-botao" />
                                </>
                            )}
                        </Button>

                        {window.location.hash !== '#/' && (
                            <span className="lnkLembrarSenha" title="A senha será enviada para seu email de cadastro." onClick={e => { { this.handleLembrarSenha(); } }}>Lembrar senha</span>
                        )}
                    </div>

                    <div className="login-page__button--Celular">
                        <Button
                            id="btnLogin"
                            className="btn-alinhado"
                            onClick={this.handleLoginClick.bind(this)}
                            disabled={this.state.loadingLogin}
                        >
                            {this.state.loadingLogin ? (
                                <>
                                    <i className="pi pi-spin pi-spinner login-btn-icon" style={{ marginRight: '8px' }} />
                                    Carregando...
                                </>
                            ) : (
                                <>
                                    <span>Acessar exames</span>
                                    <i className="pi pi-angle-right icone-do-botao" />
                                </>
                            )}
                        </Button>
                        {window.location.hash !== '#/' && (
                            <span className="lnkLembrarSenha" title="A senha será enviada para seu email de cadastro." onClick={e => { { this.handleLembrarSenha(); } }}>Lembrar senha</span>
                        )}
                    </div>
                    <div className="login-page__footer--phone">
                        <span className="login-page__version">
                            &copy; 2025 Tzion MyResult 2025.002.02.13
                        </span>
                    </div>
                    <div className="login-page__footer--tablet">
                        <span className="login-page__version">
                            &copy; 2025 Tzion MyResult 2025.002.02.13
                        </span>
                    </div>
            </div>
            :
            <License perfil={this.props.perfil} />    
        }
        </div >;

        const btnReenviarCodigo = this.state.ocultarLinkReenviarCodigo ? '' : <span
            className="lnkLembrarSenha"
            title="O código será enviado para seu email de cadastro."
            onClick={e => { this.handleReenviarCodigo() }}>Reenviar código
        </span>;

        const boxCodigoAcesso = <div>
            <div>
                <br></br>
                <div>
                    <p>Para validar o seu acesso enviamos para o seu email {this.props.emailCadastro} o código.</p>
                    <br></br>

                    <div style={{ marginBottom: "7px" }}><label>Código:</label></div>

                    <InputText
                        id="textCodigo"
                        style={{
                            backgroundImage: `url(${IcoLock})`,
                            backgroundSize: '20px',
                            backgroundRepeat: 'no-repeat',
                            backgroundPositionY: '10px',
                            backgroundPositionX: '10px',
                            padding: '12px 10px 12px 40px',
                            borderRadius: '7px',
                            width: "100%"
                        }}
                        type="password"
                        onKeyPress={this.handleKeyPress}
                        value={this.state.codigo}
                        onChange={(e) => { this.setState({ codigo: e.target.value }) }}
                        placeholder="Digite seu código"
                    />
                </div>

                <div style={{ textAlign: 'center' }}>
                    <br></br>
                    <div>
                        <Button id="btnLogin" label="Entrar" onClick={this.handleLoginClick.bind(this)} />
                    </div>
                    <br />
                    <div>
                        {btnReenviarCodigo}
                        <ProgressSpinner style={{ display: this.state.eventEnviarCodigo ? "block" : "none", width: '20px', height: '20px' }} strokeWidth="8" fill="#EEEEEE" animationDuration=".5s" />
                        {/* <span
                            className="lnkLembrarSenha"
                            title="O código será enviado para seu email de cadastro."
                            style={{ marginLeft: '20px' }}
                            onClick={e => { { this.handleNaoRecebiMeuCodigo(); } }}>Não recebi meu código
                        </span> */}
                    </div>
                </div>

            </div>
        </div>;

        const boxAlertEmailNaoCadastrado = <div>
            <br></br>
            <p dangerouslySetInnerHTML={{ __html: this.props.msgEmailNaoCadastrado ? window.atob(this.props.msgEmailNaoCadastrado) : '' }}></p>
            <div style={{ textAlign: 'center' }}>
                <br></br>
                <div>
                    <Button label="Ok" onClick={() => { window.location.reload(); }} />
                </div>
            </div>
        </div>;



        return (
            <div className="p-component-overlay"
                style={{
                    minHeight: '100vh',
                    overflowY: 'auto',
                    overflowX: 'hidden',
                    //backgroundImage: `url(layout/login/background.png)`,
                    //backgroundPosition: "top",
                    //backgroundRepeat: "no-repeat",
                    //backgroundSize: "cover"
                }}
            >

                <Toast ref={(el) => this.toast = el}
                    style={{
                        width: "400px",
                        float: "right",
                        margin: "10px",
                        position: "absolute",
                        right: "0"
                    }}
                />

                <div className="ASL-Icon">
                    {<img src={require('./../../images/logotipo-ASL-Softhouse-azul.png')} className="logoTzionTop" />}
                </div>



                <div style={{ display: 'flex' }}>

                    <div className="login-page__side-image--phone-turned">

                        <div className="login-page__side-filter">

                            <div className="whiteLogo">
                                <img src={Logo_white} />
                            </div>

                            <div >
                                <label className="login-page__title">
                                    <p>{titulo}</p>
                                </label>
                            </div>

                            <div >
                                <label className="login-page__subtitle">
                                    <p>{subtitulo}</p>
                                </label>
                            </div>
                        </div>
                    </div>


                    <div>
                        <div className="login-page__side-image--phone">

                            <div className="login-page__side-filter">
                                <div className="whiteLogo">
                                    <img src={Logo_white} />
                                </div>

                                <div className="loginBox_Text">

                                    <label className="login-page__title">
                                        <p>{titulo}</p>
                                    </label>

                                    <label className="login-page__subtitle">
                                        <p>{subtitulo}</p>
                                    </label>
                                </div>                               
                            </div>

                        </div>

                        <div className="login-page__intro-desktop">
                            <div style={{ marginBottom: "10px" }}>
                                <label className="login-page__title">
                                    <p>{titulo}</p>
                                </label>
                            </div>

                            <div style={{ marginBottom: "10px" }}>
                                <label className="login-page__subtitle">
                                    <p>{subtitulo}</p>
                                </label>
                            </div>
                        </div>

                        <div className="login-page__form">
                            {this.props.autenticacaoDoisFatores
                                ? this.state.naoRecebiMeuCodigo ? boxAlertEmailNaoCadastrado : boxCodigoAcesso
                                : boxLoginSenha}
                        </div>
                    </div>

                    <div className="login-page__side-image--desktop"
                        style={{
                            backgroundImage: `url(${carrosselImagens?.[this.state.currentImageIndex] || ""})`,
                            transition: 'background-image 1s ease-in-out'
                        }}

                    >

                        <div className="login-page__side-filter">
                            <div className="testimonal">
                                {qrcodeimagem && (
                                    <div className="login-page__qr">
                                        <div
                                            className="login-page__qr-image"
                                            style={{ backgroundImage: `url(${qrcodeimagem})` }}
                                        ></div>
                                        <p className="login-page__qr-text">{qrcodetexto}</p>
                                    </div>
                                )}

                                <Testimonial depoimentos={depoimentos || []} />
                            </div>
                        </div>
                    </div>
                </div>

                <Footer />
            </div>
        );

    }
}